import DataService from './data-service';
import axios, { API_URL } from './http-service';
import { TokenVerify } from '../components/interfaces';

export default class TokenService extends DataService {

  verify = async (): Promise<TokenVerify> => {
    const url = API_URL + '/verify-token';
    const response = await this.handler(() => axios.get(url));
    return response;
  }

}
